import Routes from './Routes';

export { Routes as default };
